<template>
    <div>
        <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
      <vs-card actionable class="cardx">
        <div slot="header">
          <h3>
            Success
          </h3>
        </div>
        <div slot="media">
          <img  src="@/assets/images/pages/right.png">
        </div>
        <div>
          <h6>Thank you! Your Payment Is Completed Successfully</h6>
        </div>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button color="primary" type="gradient" @click="goBack" >Go To Main Page</vs-button>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
   
  </vs-row>
    </div>
</template>
<script>
import { PaypalOneToOne } from '@/mixins/payment/PaypalOneToOne.js'
import {goCardCompleteRediret} from '@/api/manual-invoice'

export default {
  name: 'successCard',
  mixin: [PaypalOneToOne],
  data () {
    return {
      redirectPath: '',
      courseDetails: JSON.parse(localStorage.getItem('invoiceDetails'))
    }
  },
  mounted () {
    this.redirectToMain()
  },
  methods: {
    redirectToMain () {
      if ('redirect_flow_id' in this.$route.query) {
        this.redirectPath = this.$route.query.redirect_flow_id
        this.getMandateConfirm(this.$route.query.redirect_flow_id)
      }
    },
    async getMandateConfirm (redirect_flow_id) {
      try {
        const queryParams = {
          redirect_flow_id,
          invoice_id: this.invoiceDetails.invoice_id
        }
        console.log(queryParams)
        const data = await goCardCompleteRediret(queryParams)
        this.goCardLessApiForManualInvoice()
      } catch (error) {
        console.log('error')
      }
    },
    goBack () {
      if ('redirect_flow_id' in this.$route.query) {
        localStorage.removeItem('invoiceDetails')
        window.close()
      } else {
        this.$router.push({
          path: '/manual-invoice'
        }) 
      }
    }

  }
}
</script>
